export default [
  {
    title: '',
    body: "Amo RSS.com. Lo utilizzo da quando ho iniziato il mio podcast 4 anni fa. Sono d'accordo al 1000% sul fatto che abbiano prezzi equi. <strong>Tra tutte le 11 opzioni che stavo considerando, offrivano tutto ciò che cercavo.</strong> La cosa che preferisco di loro è che non fanno pagare per ogni funzionalità e aggiornano costantemente il loro software con nuove migliorie.",
    source: 'Reddit',
    user: 'u/famousashley',
    link: '',
    id: 1
  },
  {
    title: '',
    body: 'Sto usando RSS.com e sono molto felice di utilizzarlo. <strong>Non ha limiti sulle ore audio o sugli episodi,</strong> il che è fantastico perché carico più di 3 ore di audio ogni mese. Inoltre, ha ottime funzionalità con analisi avanzate.',
    source: 'Reddit',
    user: 'u/Temporary-Gap-2556',
    link: '',
    id: 2
  },
  {
    title: '',
    body: 'RSS.com è solido, lo uso da un anno. <strong>Sono passato da Podbean e non tornerei indietro.</strong>',
    source: 'Reddit',
    user: 'u/zerofoxtrot93',
    link: '',
    id: 3
  },
  {
    title: '',
    body: 'RSS.com è fantastico. Lo adoro!<br/><br/><strong>Le analisi sono incredibili.</strong> Molto utili e informative per far crescere un podcast.',
    source: 'Reddit',
    user: 'u/denethar',
    link: '',
    id: 4
  },
  {
    title: '',
    body: "Nel 2022 ho cercato una piattaforma per ospitare il mio podcast e <strong>alla fine ho scelto RSS.com per il prezzo conveniente, la facilità d'uso e la semplicità di distribuzione.</strong><br/><br/>Recentemente hanno reso possibile la distribuzione anche su YouTube, ma io lo faccio separatamente. Tuttavia, tutto il resto è gestito da RSS.com.<br/><br/>L'unico problema (ma non troppo grave per me) è che la pagina delle analisi non viene aggiornata quotidianamente e rimane indietro rispetto alla reale portata del pubblico. A parte questo, 5 stelle.",
    source: 'Reddit',
    user: 'u/aemarques, Música & Som Podcast',
    link: '',
    id: 5
  },
  {
    title: 'Ho iniziato recentemente il mio podcasting',
    body: "Ho iniziato recentemente il mio viaggio nel mondo del podcasting e, dopo aver esaminato diverse piattaforme di hosting, <strong>ho deciso di scegliere RSS.com—e non potrei essere più felice della mia scelta! Fin dall'inizio, la piattaforma si è dimostrata incredibilmente intuitiva e facile da usare, permettendomi di iniziare con semplicità anche come principiante.</strong> Configurare il mio podcast è stato un gioco da ragazzi. Le istruzioni passo dopo passo mi hanno aiutato a creare il mio feed RSS, inviare il mio show alle principali directory come Apple Podcasts e Spotify e persino progettare un sito web professionale per il podcast. Il pannello di analisi è estremamente utile, fornendo informazioni chiare sul mio pubblico e sulle prestazioni degli episodi. Quello che davvero distingue RSS.com è il supporto clienti. Ogni volta che ho avuto una domanda, il loro team ha risposto rapidamente ed è stato incredibilmente disponibile. Inoltre, il prezzo è trasparente e conveniente, soprattutto considerando il valore offerto. Se stai cercando una piattaforma di hosting affidabile e facile da usare che cresca con te, consiglio vivamente RSS.com. È stata una svolta per il mio percorso nel podcasting!",
    source: 'Trustpilot',
    user: 'Saeed Ahmed Agha',
    link: 'https://www.trustpilot.com/reviews/67b9c16cf0356aa1779b01ac',
    id: 6
  },
  {
    title: 'Tutto',
    body: 'Tutto: <strong>ottima UX, ottima UI,</strong> ottimo servizio e affidabile e veloce.',
    source: 'Trustpilot',
    user: 'Filip Volf',
    link: 'https://www.trustpilot.com/reviews/67b705e1b7d9182759f3c5a5',
    id: 7
  },
  {
    title: 'Sorprendentemente ho trovato questo!',
    body: 'Sono rimasto sorpreso di trovare questa piattaforma proprio quando avevo bisogno di un nuovo servizio di pubblicazione, poiché il mio vecchio provider aveva interrotto lo streaming dei podcast. Scoprire che fosse anche così facile da usare e pubblicare è stata la ciliegina sulla torta. <strong>Il mio tecnico informatico è rimasto stupito dal fatto che sia riuscito a creare il sito in così poco tempo.</strong> È ancora presto per un giudizio definitivo, ma finora sono impressionato.',
    source: 'Trustpilot',
    user: 'David Bowers',
    link: 'https://www.trustpilot.com/reviews/679d86379c03f6f29faedbf9',
    id: 8
  },
  {
    title: 'La mia esperienza finora è stata fantastica…',
    body: "La mia esperienza finora è stata fantastica perché pensavo che sarebbe stato difficile da fare, ma <strong>questa app ha reso tutto super semplice e utile.</strong> L'ansia che provavo inizialmente è completamente svanita grazie a RSS.",
    source: 'Trustpilot',
    user: 'Toni Wise',
    link: 'https://www.trustpilot.com/reviews/67ab8d635e4291003d6607c6',
    id: 9
  },
  {
    title: 'RSS.com è il miglior amico di un podcaster..',
    body: 'Rende <strong>incredibilmente facile avviare il tuo podcast</strong> senza passaggi complicati. Lo consiglio vivamente a chi è nuovo nel mondo del podcasting!',
    source: 'Trustpilot',
    user: 'Dr Andre Jerry',
    link: 'https://www.trustpilot.com/reviews/6797057f89f108d94cedce23',
    id: 10
  },
  {
    title: 'Semplice e facile da usare',
    body: '<strong>I video offrono una quantità enorme di informazioni utili,</strong> specialmente per chi è completamente nuovo nel podcasting. Grazie!',
    source: 'Trustpilot',
    user: 'Kristene Gulla',
    link: 'https://www.trustpilot.com/reviews/679d47786ac1f4dad021c2d8',
    id: 11
  },
  {
    title: 'Risorsa brillante',
    body: 'Super intuitivo e utile. <br/>Sono completamente inesperto in tutto ciò che riguarda la tecnologia. Non capisco la terminologia, i processi e, in generale, come fare nulla se non scrivere.<br/><br/>Non riesco ancora a crederci, e non ne ho ancora la prova definitiva, ma penso di essere riuscito a registrare un audio sul mio laptop, a caricarlo e a pubblicare il mio primo episodio tramite il sito web di RSS. Se ci sono riuscito, è interamente merito delle istruzioni logiche, ben spiegate e sequenziali fornite sulla piattaforma. Anche se non ci fossi riuscito, mi sento comunque felice invece di provare la mia solita frustrazione per non essere in grado di fare nulla al di fuori della scrittura! <strong>Mi sento motivato a continuare! Complimenti a RSS finora!</strong>',
    source: 'Trustpilot',
    user: 'Sally Ann Jackson',
    link: 'https://www.trustpilot.com/reviews/6775dc51d324ada81165b4b7',
    id: 12
  },
  {
    title: 'RSS lo ha reso così semplice',
    body: "Ero sempre nervoso all'idea di avviare un podcast perché non sapevo da dove iniziare per pubblicare un episodio. <strong>RSS ha reso tutto così facile che avrei voluto iniziare prima!</strong>",
    source: 'Trustpilot',
    user: 'Alli Wilber',
    link: 'https://www.trustpilot.com/reviews/6779e57eb1843bd14be6e16f',
    id: 13
  },
  {
    title: 'Molto facile da usare',
    body: 'Questo è un servizio fantastico per i podcaster. <strong>È molto intuitivo</strong> e siamo davvero felici di utilizzare questa piattaforma.',
    source: 'Trustpilot',
    user: 'Telling Tinder Tales',
    link: 'https://www.trustpilot.com/reviews/6797dd9a52fd71127c2cca8b',
    id: 14
  },
  {
    title: 'Se sei nuovo nel podcasting, questa azienda è il posto giusto per te.',
    body: "Devi assolutamente provarlo! È stato veloce e facile avviare il mio podcast, anche con la mia disabilità visiva. Sono stato in grado di vedere tutto sul sito web senza l'ausilio che solitamente utilizzo per digitare al computer. <strong>Questa azienda rende semplice per chiunque, anche senza competenze professionali, avviare il proprio podcast.</strong>",
    source: 'Trustpilot',
    user: 'Minister Andrea Johnson',
    link: 'https://www.trustpilot.com/reviews/674aea0c455b87dbebec0c1d',
    id: 15
  },
  {
    title: 'Le persone e il team di RSS sono sempre…',
    body: '<strong>Le persone e il team di RSS cercano sempre di essere un passo avanti rispetto alle altre piattaforme. Il servizio clienti è eccezionale!</strong> Trovano sempre modi per rendere più facile far notare il tuo show al pubblico. Sono con loro da 5 anni e il loro servizio è sempre stato impareggiabile.',
    source: 'Trustpilot',
    user: 'Broad St South',
    link: 'https://www.trustpilot.com/reviews/6747c051a49b562647c92b3f',
    id: 16
  },
  {
    title: 'Una grande piattaforma per i podcaster principianti!',
    body: "<strong>La piattaforma rss.com è facile da usare per i principianti.</strong> Caricare e pubblicare un podcast richiede solo pochi minuti. Appena l'episodio viene pubblicato, l'URL è pronto per la condivisione e il sito web corrispondente è online. È un'esperienza molto piacevole.",
    source: 'Trustpilot',
    user: 'Ying Zhou',
    link: 'https://www.trustpilot.com/reviews/6730e0dca3c39df26476167a',
    id: 17
  },
  {
    title: 'Ho già usato RSS in passato e quando ho…',
    body: "Ho già usato RSS in passato e quando ho deciso di avviare un altro podcast ho fatto delle ricerche e ho pensato di provare uno degli host più 'popolari'... pessima idea! RSS è molto più semplice da usare ed è molto più completo, soprattutto nella distribuzione automatica. Gli altri host che ho provato richiedevano molto più lavoro manuale, incluso il dover riconfigurare il file audio in un altro formato, un processo lungo e frustrante. <strong>RSS è una passeggiata ed è senza dubbio il più semplice di tutti... e ne ho provati 3 tra i più 'famosi'.</strong> Inoltre, su RSS tutto è illimitato, mentre gli altri host hanno prezzi più alti e limitazioni su ciò che puoi fare e archiviare... non RSS!!",
    source: 'Trustpilot',
    user: 'John Alexander',
    link: 'https://www.trustpilot.com/reviews/670d7c17245bd6337814d7b5',
    id: 18
  },
  {
    title: 'Ottimo servizio',
    body: "Ho provato un paio di servizi prima di RSS.com e devo dire che <strong>offre uno dei migliori rapporti qualità-prezzo sul mercato.</strong> L'interfaccia è estremamente intuitiva, perfetta per principianti, e rende l'avvio di un podcast un gioco da ragazzi.",
    source: 'Trustpilot',
    user: 'Devon & Jonathan Grey',
    link: 'https://www.trustpilot.com/reviews/6734f6a11179b8de3c5c3de7',
    id: 19
  },
  {
    title: 'Adoro la mia esperienza con RSS…',
    body: 'Adoro la mia esperienza con la pubblicazione del mio primo podcast! È stato semplice e diretto e mi permette di modificare il contenuto tutte le volte che voglio prima di renderlo pubblico. <strong>Mi piace il fatto che mi consenta di aggiungere la trascrizione automaticamente o manualmente, oltre alla possibilità di suddividere gli episodi in capitoli, se necessario.</strong>',
    source: 'Trustpilot',
    user: 'Jiaxin Li',
    link: 'https://www.trustpilot.com/reviews/66f9e045b55c41e604372bb6',
    id: 20
  },
  {
    title: 'Facile da usare',
    body: 'Facile da usare, veloce e rapido nel caricamento.',
    source: 'Trustpilot',
    user: 'Leona',
    link: 'https://www.trustpilot.com/reviews/67b2ad4be775315f2632a970',
    id: 21
  },
  {
    title: 'Wow!!!!!',
    body: "<strong>Così facile! Perché non l'ho fatto prima?!???</strong><br/><br/>Esperienza fantastica, ora pubblicherò molti più episodi!!!!",
    source: 'Trustpilot',
    user: 'Nick Materese',
    link: 'https://www.trustpilot.com/users/67675527765b7a220231a316',
    id: 22
  },
  {
    title: 'Tutti dovrebbero iscriversi',
    body: 'Sono con RSS da 3 anni ed è una piattaforma così facile da navigare, che permette di rendere i tuoi contenuti audio il più visibili possibile. La mia azienda è cresciuta con ascoltatori da tutto il mondo grazie al livello di professionalità che RSS.com offre ai suoi utenti. <strong>Tutti dovrebbero iscriversi a RSS.com!</strong>',
    source: 'Trustpilot',
    user: 'Broad St South',
    link: 'https://www.trustpilot.com/reviews/6693ea921e131e4058b363e0',
    id: 23
  },
  {
    title: 'Ottimo per i principianti',
    body: 'Molto facile da usare e intuitivo per i principianti. Così professionale. Nessuna sorpresa nascosta. Lo adoro assolutamente. <strong>Sono felice di aver scelto questa piattaforma rispetto alle altre per avviare il mio podcast.</strong> Adoro i tutorial e le guide su come iniziare e rendere il proprio podcast di successo.',
    source: 'Trustpilot',
    user: 'Zinhle Bhembe',
    link: 'https://www.trustpilot.com/reviews/666c8a555f248d8e402e6f9e',
    id: 24
  },
  {
    title: 'Brillante, grazie!',
    body: "Ho iniziato questa esperienza per caso, in modo che i miei clienti potessero ascoltarmi invece di dover guardare un video, ed è stato così facile! Grazie! <strong>Podcast di 30 minuti registrato, caricato e completato in meno di un'ora.</strong> Fantastico!",
    source: 'Trustpilot',
    user: 'Anna Martin',
    link: 'https://www.trustpilot.com/reviews/674054e5404fbaae63e03d42',
    id: 25
  },
  {
    title: 'Facile come 1, 2, 3!',
    body: '<strong>Così facile da usare e seguire.</strong> Sono un professionista nel settore della produzione media, ma questa è la prima volta che lavoro da solo, quindi è rassicurante sapere che RSS mi sostiene nella diffusione dei miei contenuti.',
    source: 'Trustpilot',
    user: 'Michelle Langthorne',
    link: 'https://www.trustpilot.com/reviews/665b33ddb1cddf62a44f6666',
    id: 26
  },
  {
    title: 'Usare RSS è stata la parte più semplice di…',
    body: "Usare RSS è stata la parte più semplice nella creazione del mio podcast! <strong>Le istruzioni sono chiare, l'interfaccia pulita e i risultati immediati.</strong> Grazie, RSS!",
    source: 'Trustpilot',
    user: 'Mary Barbara Hanna',
    link: 'https://www.trustpilot.com/reviews/6737517feb551c5d6dcd0cf1',
    id: 27
  },
  {
    title: 'Sono così felice',
    body: 'Sono così felice! <strong>Ho appena creato il mio primo podcast su RSS in meno di 5 minuti.</strong> Tuttavia, devo ancora imparare di più. Ho solo provato per la prima volta.<br/><br/>Grazie RSS.',
    source: 'Trustpilot',
    user: 'Puru Thapa',
    link: 'https://www.trustpilot.com/reviews/67870b17fab25d0d26db70e6',
    id: 28
  },
  {
    title: 'È stato un gioco da ragazzi!',
    body: "Pubblicare il mio primo episodio è stato un gioco da ragazzi. <strong>Raramente è così semplice trasformare un'idea in un prodotto concreto, ma in questo caso è stato facile come 3,14!</strong> Il mio podcast, NI vs. AI, è ora online. Che emozione! Grazie, RSS.com! Non vedo l'ora di esplorare tutte le altre funzionalità.",
    source: 'Trustpilot',
    user: 'Customer (senza nome)',
    link: 'https://www.trustpilot.com/reviews/66d7319d9c8ccdf46fe57eca',
    id: 29
  },
  {
    title: 'È stato così facile!!!',
    body: 'È stato così facile!!!! Sono rimasto impressionato dalle recensioni sulla piattaforma RSS.com e ho deciso di provarla. <strong>Sono molto felice di quanto sia stato fluido il processo!!!</strong>',
    source: 'Trustpilot',
    user: 'Alberto Rocha',
    link: 'https://www.trustpilot.com/reviews/677f736d9d9a5a52d7f73fb8',
    id: 30
  },
  {
    title: 'Piattaforma eccellente per i podcaster!',
    body: "Sto utilizzando RSS.com per ospitare il mio podcast ed è stata un'esperienza eccellente finora. La piattaforma è intuitiva e offre tutti gli strumenti essenziali per caricare e gestire gli episodi senza problemi. <strong>La funzione di analisi è particolarmente utile per comprendere meglio il mio pubblico.</strong> Inoltre, il team di supporto è sempre disponibile e pronto ad aiutare con qualsiasi domanda. <strong>Consiglio vivamente RSS.com</strong> sia ai nuovi podcaster che a quelli più esperti in cerca di un servizio di hosting affidabile.",
    source: 'Trustpilot',
    user: 'Dïänä Jin',
    link: 'https://www.trustpilot.com/reviews/66aaeea83468df8990dffbba',
    id: 31
  },
  {
    title: 'Un modo fantastico per i principianti di iniziare…',
    body: 'Un modo fantastico per i principianti di avviare un podcast!',
    source: 'Trustpilot',
    user: 'Heavenly Minded Academy',
    link: 'https://www.trustpilot.com/reviews/6798eb9610a0a1d93ef2cc3c',
    id: 32
  },
  {
    title: 'La facilità di modifica sullo schermo o su telefono',
    body: '<strong>La facilità di modifica sullo schermo o sul telefono è incredibile</strong> e il prezzo per il servizio a pagamento è equo!',
    source: 'Trustpilot',
    user: 'Onshalique Wilson',
    link: 'https://www.trustpilot.com/reviews/677fdf3cd7fd877acb4cda98',
    id: 33
  },
  {
    title: 'Ho avuto difficoltà con altre piattaforme…',
    body: "Ho avuto difficoltà con altre piattaforme, ma nessuna offre nemmeno la metà di quello che fornisce RSS.com.<br/><br/><strong>Facile da usare e la pubblicazione è semplice.</strong> Non vedo l'ora di pubblicare molti più episodi molto presto.",
    source: 'Trustpilot',
    user: 'John',
    link: 'https://www.trustpilot.com/reviews/66806eaafced63b6f7896465',
    id: 34
  },
  {
    title: 'Incredibile!',
    body: '<strong>Tutto è così semplice e facile da usare, il prezzo è ragionevole</strong> ed è perfetto per creare e ospitare il tuo RSS! Lo consiglio vivamente!',
    source: 'Trustpilot',
    user: 'Delilah Beau',
    link: 'https://www.trustpilot.com/reviews/664433ee49efab8edddc4d63',
    id: 35
  },
  {
    title: 'Ho due podcast in tedesco ospitati su RSS.com…',
    body: 'Ho due podcast in tedesco ospitati su RSS.com ed <strong>è semplice e facile da usare.</strong><br/><br/>Nessuna lamentela da parte mia.',
    source: 'Trustpilot',
    user: 'Patrick',
    link: 'https://www.trustpilot.com/reviews/677bdd143f0a3a67f71d2bf1',
    id: 36
  },
  {
    title: 'Facile come 1-2-3',
    body: 'Sono completamente nuovo alla creazione di contenuti in generale, per non parlare del podcasting. <strong>RSS ha reso tutto così facile come 1-2-3.</strong>',
    source: 'Trustpilot',
    user: 'tinns',
    link: 'https://www.trustpilot.com/reviews/666d18edef50fd91a57b2aab',
    id: 37
  },
  {
    title: 'Ho appena caricato il mio primo podcast!!!',
    body: 'Ho appena finito di caricare il mio primo podcast e <strong>RSS.com ha reso tutto così facile per iniziare!</strong> Dopo aver passato ore nelle ultime due settimane a cercare informazioni, ho trovato tutto ciò di cui avevo bisogno qui, spiegato in modo semplice e chiaro! WOW! Amo già usare RSS.com!',
    source: 'Trustpilot',
    user: 'Terry Jarrell',
    link: 'https://www.trustpilot.com/reviews/667fa2d76f2cdee28b728560',
    id: 38
  },
  {
    title: 'Facile, fantastico e divertente',
    body: "Facile, fantastico, divertente.<br/><br/>Esprimere i tuoi pensieri nel mondo - è stato facile. Invece di lasciare i tuoi contenuti a prendere polvere nell'app di memo vocali, dagli una nuova vita permettendo al mondo di ascoltarli!",
    source: 'Trustpilot',
    user: 'Maria Abdel Rahman',
    link: 'https://www.trustpilot.com/reviews/6681dd04dc411e9e004ef40b',
    id: 39
  },
  {
    title: 'Ho visitato siti web tutto il giorno…',
    body: 'Ho visitato siti web tutto il giorno finché non ho trovato questo, che mi ha permesso di creare il mio podcast con facilità.',
    source: 'Trustpilot',
    user: 'Bantaboyz Z&L',
    link: 'https://www.trustpilot.com/reviews/66716a79b9ef13d512faef82',
    id: 40
  },
  {
    title: 'Questo processo è stato così semplice',
    body: "<strong>Questo processo è stato così semplice,</strong> per mesi ci ho pensato troppo e finalmente l'ho fatto. Dall'inizio alla fine non ci ho messo più di 15 minuti.",
    source: 'Trustpilot',
    user: 'Maritza',
    link: 'https://www.trustpilot.com/reviews/668698bc3c268accee41dfac',
    id: 41
  },
  {
    title: 'Il processo',
    body: "<strong>Il processo è stato facile</strong> e non vedo l'ora che le persone possano beneficiare degli episodi. Grazie!",
    source: 'Trustpilot',
    user: 'Dr. Reginald Woods',
    link: 'https://www.trustpilot.com/reviews/66fdf90d48e3c73b4371f0bc',
    id: 42
  },
  {
    title: 'Ottimo supporto!',
    body: 'Supporto! Ana... fenomenale!!! Mi ha guidato nel processo dopo che avevo commesso un errore. Fantastico! Facile da fare!',
    source: 'Trustpilot',
    user: 'Billy Burke',
    link: 'https://www.trustpilot.com/reviews/666887b96b313d48cb77456a',
    id: 43
  },
  {
    title: 'Grazie RSS.com!',
    body: 'Ho provato a iniziare con YouTube e Spotify, ma <strong>RSS.com è molto più semplice per i principianti.</strong>',
    source: 'Trustpilot',
    user: 'Noel Hoines',
    link: 'https://www.trustpilot.com/reviews/666ad6f406ff1c80ae59de1c',
    id: 44
  },
  {
    title: 'Entusiasta dello strumento podcast di RSS.com',
    body: "L'esperienza è fantastica, portare Radio Fortune Africa al livello successivo è stata una vera benedizione.",
    source: 'Trustpilot',
    user: 'Cantona Joseph',
    link: 'https://www.trustpilot.com/reviews/66e812bcd2be99d1b9e8bc35',
    id: 45
  },
  {
    title: 'Creare e pubblicare un podcast non è mai stato così facile',
    body: 'Creare e pubblicare un podcast non è mai stato così semplice, <strong>offrono tutto ciò di cui hai bisogno senza alcuno sforzo e in cinque minuti il tuo podcast è disponibile su Internet,</strong> e, cosa più importante, hai un mese gratuito. Finora, è di gran lunga il miglior servizio che ho ricevuto.',
    source: 'Trustpilot',
    user: 'ilias ro',
    link: 'https://www.trustpilot.com/reviews/66d0850642bd80a9974a9c8a',
    id: 46
  },
  {
    title: 'Una scoperta eccezionale',
    body: "Qualità eccellente e facilità d'uso. È semplice. Grafica raffinata. Ben spiegato. ALTA QUALITÀ. FACILITÀ D'USO × MOLTO UTILE.",
    source: 'Trustpilot',
    user: "Taveau D'Arcy",
    link: 'https://www.trustpilot.com/reviews/667d9b8002e1c964db82dd9c',
    id: 47
  },
  {
    title: "Supporto eccezionale e facilità d'uso",
    body: 'Grazie mille per tutto il vostro aiuto e supporto.',
    source: 'Trustpilot',
    user: 'Susan Post',
    link: 'https://www.trustpilot.com/reviews/6795ad71320b2becdafb401d',
    id: 48
  },
  {
    title: 'La semplicità prima di tutto',
    body: 'La semplicità offre un accesso intuitivo senza paragoni rispetto ad altre piattaforme.',
    source: 'Trustpilot',
    user: 'City Grant',
    link: 'https://www.trustpilot.com/reviews/674213cec5951cf7dcf4818e',
    id: 49
  },
  {
    title: 'Davvero facile per chi non ha familiarità con la tecnologia',
    body: "<strong>È stato super facile.</strong> Non ho avuto bisogno dell'aiuto dei miei figli per guidarmi, il che è tutto dire.",
    source: 'Trustpilot',
    user: 'D Renee Neal',
    link: 'https://www.trustpilot.com/reviews/67369a087d805e406bfbd89c',
    id: 50
  },
  {
    title: 'Ha reso così semplice pubblicare il mio primo episodio…',
    body: '<strong>Ha reso così semplice pubblicare il mio primo episodio di podcast.</strong> Grazie per aver mantenuto la tecnologia semplice.',
    source: 'Trustpilot',
    user: 'Angie Engstrom',
    link: 'https://www.trustpilot.com/reviews/664e110b319791c31fd628f7',
    id: 51
  },
  {
    title: 'Molto facile da usare',
    body: 'Molto facile da usare; istruzioni chiare e semplici da capire.',
    source: 'Trustpilot',
    user: 'Paige Retchko',
    link: 'https://www.trustpilot.com/reviews/66b541d35fb3cf321f58564f',
    id: 52
  },
  {
    title: 'Davvero facile e intuitivo da usare',
    body: "Davvero facile e intuitivo da usare. Non avrei potuto chiedere un'installazione più semplice.",
    source: 'Trustpilot',
    user: 'Joel Fortune',
    link: 'https://www.trustpilot.com/reviews/6701ecd0b454e3c883c151b7',
    id: 53
  },
  {
    title: 'RSS è incredibile!',
    body: 'RSS è fantastico! <strong>Facile, intuitivo, servizio 10/10.</strong>',
    source: 'Trustpilot',
    user: 'Andrew George',
    link: 'https://www.trustpilot.com/reviews/67632d5181d2f39815a41b43',
    id: 54
  },
  {
    title: 'Facile da usare, grazie!',
    body: 'Questo sito web ha reso davvero facile iniziare; grazie!',
    source: 'Trustpilot',
    user: 'Jack Cunningham',
    link: 'https://www.trustpilot.com/reviews/67439443c6f9f56a6a9be7ab',
    id: 55
  },
  {
    title: '',
    body: "Ho avuto un'esperienza eccellente con questa piattaforma. <strong>È stata molto facile da usare,</strong> con un'interfaccia intuitiva che mi ha permesso di navigare senza problemi. Ho trovato rapidamente ciò di cui avevo bisogno e tutto ha funzionato alla perfezione. <strong>Senza dubbio, la consiglio ad altri.</strong> Ottimo lavoro!",
    source: 'Reviews.io',
    user: 'Customer',
    link: 'https://www.reviews.io/company-review/store/rss-com/24825854',
    id: 56
  },
  {
    title: '',
    body: "<strong>Prezzi ragionevoli e navigazione facile,</strong> cos'altro si può chiedere?",
    source: 'Reviews.io',
    user: 'Customer',
    link: 'https://www.reviews.io/company-review/store/rss-com/24775309',
    id: 57
  },
  {
    title: '',
    body: 'Ho creato un profilo e impostato tutto per il mio podcast dopo aver appena sentito parlare di questo programma oggi. È stata la parte più semplice di tutto il processo.',
    source: 'Reviews.io',
    user: 'Customer',
    link: 'https://www.reviews.io/company-review/store/rss-com/24516463',
    id: 58
  },
  {
    title: '',
    body: 'È la prima volta che realizzo un podcast per un compito scolastico, e <strong>RSS ha reso tutto incredibilmente facile</strong> e semplice. Ci ho messo al massimo cinque minuti per creare il mio account e pubblicare il mio podcast. Perfetto e super intuitivo per i principianti!',
    source: 'Reviews.io',
    user: 'Customer',
    link: 'https://www.reviews.io/company-review/store/rss-com/24391603',
    id: 59
  },
  {
    title: '',
    body: 'RSS.com è una piattaforma eccellente per avviare e gestire un podcast. <strong>La sua interfaccia intuitiva rende facile caricare episodi, monitorare le analisi e distribuire i contenuti sulle principali piattaforme.</strong> I prezzi sono accessibili e il supporto clienti è eccellente. Per i podcaster che vogliono condividere i propri contenuti senza problemi, RSS.com è una scelta fantastica.',
    source: 'Reviews.io',
    user: 'Customer',
    link: 'https://www.reviews.io/company-review/store/rss-com/24377327',
    id: 60
  },
  {
    title: '',
    body: "RSS.com è una piattaforma di hosting per podcast molto intuitiva che offre spazio di archiviazione illimitato, gestione semplice degli episodi e distribuzione automatica alle principali directory come Apple Podcasts e Spotify. <strong>Inoltre, offre analisi dettagliate e diverse opzioni di monetizzazione,</strong> rendendola un'ottima scelta sia per i nuovi podcaster che per quelli più esperti alla ricerca di soluzioni complete per il podcasting.",
    source: 'Reviews.io',
    user: 'Customer',
    link: 'https://www.reviews.io/company-review/store/rss-com/24329503',
    id: 61
  },
  {
    title: '',
    body: "Sono rimasto davvero impressionato dalla mia prima esperienza con RSS.com per avviare il mio percorso nel podcasting. L'interfaccia intuitiva e user-friendly ha reso l'intero processo fluido e senza intoppi, anche per un principiante assoluto come me.\n\n<strong>Uno dei punti di forza è la distribuzione automatica sulle principali piattaforme come Spotify, Apple Podcasts e Google Podcasts, che mi ha fatto risparmiare molto tempo e fatica.</strong> Gli strumenti di analisi sono altrettanto fantastici: chiari, dettagliati e incredibilmente utili per monitorare le prestazioni e la crescita del mio podcast.\n\nAdoro anche i prezzi accessibili e le funzionalità illimitate, come lo spazio di archiviazione e il numero di episodi. È la scelta perfetta per chiunque voglia concentrarsi sulla creazione di contenuti senza preoccuparsi di limitazioni tecniche.\n\nSe stai cercando una piattaforma di podcasting professionale, facile da usare e affidabile, sono sicuro che RSS.com supererà le tue aspettative.",
    source: 'Reviews.io',
    user: 'Customer',
    link: 'https://www.reviews.io/company-review/store/rss-com/24267263',
    id: 62
  },
  {
    title: '',
    body: '<strong>Processo super facile,</strong> con ottimi video su YouTube che mi hanno guidato. 10/10 lo consiglio vivamente.',
    source: 'Reviews.io',
    user: 'Customer',
    link: 'https://www.reviews.io/company-review/store/rss-com/24168321',
    id: 63
  },
  {
    title: '',
    body: 'Sono così grato a RSS.com. Questa è la prima volta che realizzo un podcast, e <strong>RSS.com ha reso tutto così semplice.</strong> Grazie di cuore, siete persone davvero gentili!',
    source: 'Reviews.io',
    user: 'Customer',
    link: 'https://www.reviews.io/company-review/store/rss-com/23878139',
    id: 64
  },
  {
    title: '',
    body: "Questo è <strong>facile per i principianti e veloce da caricare.</strong> Sono impressionato dalla piattaforma finora. Non vedo l'ora di scoprire cosa riserva il futuro.",
    source: 'Reviews.io',
    user: 'Customer',
    link: 'https://www.reviews.io/company-review/store/rss-com/23854575',
    id: 65
  },
  {
    title: '',
    body: '<strong>Molto facile e intuitivo.</strong> È così semplice che ci sono riuscito senza problemi.',
    source: 'Reviews.io',
    user: 'Customer',
    link: 'https://www.reviews.io/company-review/store/rss-com/23459064',
    id: 66
  },
  {
    title: '',
    body: 'Un ottimo posto per avviare un podcast. <strong>Molto facile da usare.</strong> Ti guida passo dopo passo lungo tutto il processo. Anche un principiante assoluto potrebbe pubblicare un podcast senza difficoltà!',
    source: 'Reviews.io',
    user: 'Customer',
    link: 'https://www.reviews.io/company-review/store/rss-com/23363534',
    id: 67
  },
  {
    title: '',
    body: 'Veloce e <strong>estremamente intuitivo</strong> con una guida passo dopo passo da parte di un team straordinario.',
    source: 'Reviews.io',
    user: 'Customer',
    link: 'https://www.reviews.io/company-review/store/rss-com/23316585',
    id: 68
  },
  {
    title: '',
    body: '<strong>Ottima interfaccia, molto intuitiva.</strong> Quello che sembrava complicato su altre piattaforme, qui è stato davvero semplice e motivante.',
    source: 'Reviews.io',
    user: 'Customer',
    link: 'https://www.reviews.io/company-review/store/rss-com/22942303',
    id: 69
  },
  {
    title: '',
    body: '<strong>Una soluzione eccellente che fa risparmiare tempo</strong> e aiuta a far conoscere il nostro podcast!',
    source: 'Reviews.io',
    user: 'Customer',
    link: 'https://www.reviews.io/company-review/store/rss-com/22767107',
    id: 70
  },
  {
    title: '',
    body: "Quando Spotify for Podcasters ha completamente integrato la sua nuova piattaforma di hosting, TUTTO è cambiato: la funzione di registrazione e modifica, che prima era ergonomica e fluida, è praticamente sparita (e se non stavi attento, rischiavi di perdere tutti i tuoi episodi di podcast… *coff* io *coff*). <strong>RSS è stata la mia ancora di salvezza per continuare il mio podcast. Ho provato altre tre piattaforme di hosting, ma nessuna è stata così fluida e veloce.</strong> RSS è un'opzione incredibile per tutti. GRAZIE RSS!!!",
    source: 'Reviews.io',
    user: 'Customer',
    link: 'https://www.reviews.io/company-review/store/rss-com/22598681',
    id: 71
  },
  {
    title: '',
    body: 'RSS.com è fantastico! Ha reso il lancio del nostro podcast, "Dakdekker Amersfoort", super semplice. <strong>Ottimo supporto e analisi eccellenti.</strong> Lo consiglio vivamente!',
    source: 'Reviews.io',
    user: 'Customer',
    link: 'https://www.reviews.io/company-review/store/rss-com/22511997',
    id: 72
  },
  {
    title: '',
    body: "Questa è la mia prima volta qui e l'esperienza è stata assolutamente incredibile perché è tutto così facile! Sono un podcaster alle prime armi e sto facendo tutto da solo, quindi <strong>l'accesso e le informazioni fornite sono MOLTO utili!</strong> Non vedo l'ora di scoprire dove mi porterà questo percorso. Grazie!",
    source: 'Reviews.io',
    user: 'Customer',
    link: 'https://www.reviews.io/company-review/store/rss-com/22349023',
    id: 73
  },
  {
    title: '',
    body: 'Facile da configurare e iniziare.',
    source: 'Facebook',
    user: 'Mike Jonjak',
    link: '',
    id: 74
  },
  {
    title: '',
    body: "<strong>Amo questo servizio!</strong> Volevo avviare un podcast nel settore dell'affiliate marketing da un po' di tempo, ma ero titubante perché non sapevo come gestire l'hosting e la distribuzione. Poi abbiamo iniziato a lavorare con RSS ed è stato tutto così semplice. <strong>Mi ci è voluto più tempo per scrivere la descrizione del mio podcast che per configurarlo!</strong> Era così facile che non ero nemmeno sicuro di aver fatto tutto correttamente, ma invece sì! Lo adoro e rende davvero semplice iniziare. Lo consiglio vivamente.",
    source: 'Facebook',
    user: 'Jamie Birch',
    link: '',
    id: 75
  }
]
